import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('LIBRARY', {
  LIBRARY_REQUEST: null,
  LIBRARY_SUCCESS: null,
  LIBRARY_FAILURE: null
});
